import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { getUser, getToken, setConfirmPurchaseRoute } from "../../Utils/Common";
import { useSelector, useDispatch } from "react-redux";
import { setUserCredits } from "../../features/counter/counterSlice";
import ReactStars from "react-rating-stars-component";

function BookDetail() {
  const [avgRating, setAvgRating] = useState(null);
  const [loader, setLoader] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [data, setData] = useState([]);
  const [sucessMessage, setsucessMessage] = useState("");
  const [error, setError] = useState([]);
  const dispatch = useDispatch();
  const [authUser, setAuthUser] = useState("");
  const { book_code } = useParams();
  const user = getUser();
  const token = getToken();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("loading");
    const axiosOptions = {
      url: process.env.REACT_APP_API_URL + `v1/guest/book-detail/${book_code}`,
      method: "get",
      headers: {
        Accept: "application/json",
      },
    };

    axios(axiosOptions)
      .then((response) => {
        console.log(response.data.data);
        setData(response.data.data);
        setAvgRating(response.data.data.average_rating);
        setLoader(false);
        console.log(response.data.data.average_rating);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response.status === 404) {
          setErrorMessage(err.response.data.message);
        }
      });
  }, []);

  console.log(user);
  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   setError(null);
  //   setsucessMessage("");

  //   var formData = new FormData();
  //   formData.append("book_code", book_code);
  //   formData.append("user_id", user.id);

  //   axios({
  //     method: "post",
  //     url: `${process.env.REACT_APP_API_URL}v1/user/purchase-book`,
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${token}`,
  //     },
  //     data: formData,
  //   })
  //     .then((response) => {
  //       console.log(response.data.data);
  //       if (response.status === 200) {
  //         setsucessMessage(response.data.message);
  //         localStorage.setItem("thanks message", response.data.message);
  //         localStorage.setItem("book code", book_code);
  //         dispatch(setUserCredits(response.data.data));
  //         navigate("/user/thanks");
  //       }
  //     })
  //     .catch((error) => {
  //       if (error.response.status === 422) {
  //         setError(error.response.data.message);
  //       } else if (error.response.status === 401) {
  //         setError(error.response.data.message);
  //       } else if (error.response.status === 500) {
  //         setError(error.response.data.message);
  //       } else if (error.response.status === 402) {
  //         setError(error.response.data.message);
  //       } else {
  //         setError("Something went wrong. Please try again later.");
  //       }
  //     });
  // };

  const handleMove = () => {
    console.log("click me");
    if (!user) {
      setConfirmPurchaseRoute("common");
      navigate("/login");
    }

    if (user.user_type === 1 && user.is_active === 1) {
      setConfirmPurchaseRoute("admin");
      navigate("/admin/books");
    } else if (user.user_type === 2 && user.is_active === 1) {
      // navigate('/confirm-purchase/' + book_code)
      setConfirmPurchaseRoute("user");
    }
  };

  // console.log(user.user_type);

  const averageRating = {
    size: 25,
    count: 5,
    isHalf: true,
    value: data.average_rating,
    color: "grey",
    activeColor: "#000",
    edit: false,
  };

  return (
    <>
      <div
        className="container-xxl"
        id="kt_content_container"
        style={{ marginTop: "140px" }}
      >
        {/* Loader */}
        <div className="d-flex justify-content-center">
          <div
            className={loader === true ? "spinner-border" : ""}
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>

        {/* Body */}
        <div className="card mb-5 mb-xl-10">
          {/* Breadcrumb */}
          <div style={{ marginTop: "30px" }}>
            <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1 ps-9 pe-5">
              <li className="breadcrumb-item text-muted fs-4">
                <Link to={`/lingostory`}>Lingostory</Link>
              </li>
              <li className="breadcrumb-item fs-4">
                <span className="bullet bg-gray-300 w-5px h-2px" />
              </li>
              <li className="breadcrumb-item text-dark fs-4">Book Detail</li>
            </ul>
          </div>

          {/* Handle Errors */}
          <div className="text-center">
            <p className="fs-3 text-danger">{error ? error : ""}</p>
            <p className="fs-3 text-success">{sucessMessage}</p>
          </div>

          {Object.entries(data).length > 0 ? (
            <div className="card-body p-9">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 offset-xl-1">
                  <img
                    src={data.image_path}
                    alt="Book Cover Image"
                    className="img-fluid"
                    style={{ maxHeight: "423px" }}
                  />
                </div>

                <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-6">
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2">
                      <h1 className="fw-bold fs-2tx">{data.title}</h1>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2">
                      <div className="d-flex fw-bold fs-1">
                        <label className="">By: </label>
                        <label className="ps-1">{data.author}</label>
                      </div>
                    </div>

                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2">
                      <div className="d-flex fw-bold fs-1">
                        <label className="">Difficulty: </label>
                        <label className="ps-1">{data.difficulty}</label>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2">
                      <div className="d-flex fw-bold fs-1">
                        <label className="">Length: </label>
                        <label className="ps-1">
                          {data.hours} <span>Hrs</span> and {data.minutes}
                          <span>Min</span>
                        </label>
                      </div>
                    </div>

                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2">
                      <div className="d-flex fw-bold fs-1">
                        <label className="">Release Date: </label>
                        <label className="ps-1">{data.createdAt}</label>
                      </div>
                    </div>

                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2">
                      <div className="d-flex fw-bold fs-1">
                        <ReactStars {...averageRating} />
                        <span className="mt-1 fs-1">
                          <strong>
                            {data.average_rating} ({data.notations} notations)
                          </strong>
                        </span>
                      </div>
                    </div>

                    <div className="col-12" onClick={handleMove}>
                      {/* <Link
                        to={`/confirm-purchase/${book_code}`}
                        onClick={handleMove}
                        className="btn btn-dark w-100 mt-3 fs-1 p-1"
                      >
                        Buy now audio book + ebook with one credit
                      </Link> */}
                      <Link
                        to={`/confirm-purchase/${book_code}`}
                        className="btn btn-dark w-100 mt-3 p-2"
                      >
                        Buy now audio book + ebook with one credit
                      </Link>
                    </div>
                    <div className="col-12">
                      {data.chapters.length > 0 ? (
                        <>
                          <Link
                            to={`/guest/${book_code}/read`}
                            className="btn btn-outline-dark w-100 mt-6 m-0 p-1 fw-bolder"
                            style={{ border: "2px solid #000" }}
                          >
                            Access to free sample of the book
                          </Link>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
}

export default BookDetail;
